/**
 * @file Renders the investment drawer footer with the funding source description list.
 */
import { Descriptions } from "antd";
import type { DescriptionsProps } from "antd";

import useItems from "./helpers/useItems";
import type { Investment, UpdateInvestment } from "../../types";

import "./Footer.css";

type Props = {
  investment: Investment;
  updateInvestment: UpdateInvestment;
};

/**
 * Renders the funding source descriptions for an investment in the drawer footer.
 */
const Footer = ({
  investment,
  updateInvestment,
}: Props) => {
  const items = useItems(investment, updateInvestment);

  const descriptionsProps: DescriptionsProps = {
    size: "small",
    column: 1,
    className: "black",
    bordered: false,
    items,
  };

  return (
    <div className="investment-header">
      <Descriptions {...descriptionsProps} />
    </div>
  );
};

export default Footer;
